module.exports = __webpack_public_path__ + "img/logo-dark.facb4e9b.png";